import LightningIcon from './icons/lightning.svg';
import ShareIcon from './icons/share.svg';
import { BannerType } from './types';
export var createShareBannerConfig = function (onPrimaryClick, onClose) { return ({
    type: BannerType.Share,
    bannerProps: {
        title: 'Invite barbers to Engage',
        description: 'Allow barbers to send campaigns with your full visibility.',
        buttonText: 'Invite barbers',
        onPrimaryClick: onPrimaryClick,
        onClose: onClose,
        Icon: ShareIcon,
    },
}); };
export var createAutomatedCampaignBannerConfig = function (onSetupAutomatedCampaign, onClose) { return ({
    type: BannerType.AutomatedCampaign,
    bannerProps: {
        title: 'Squire Automated Campaigns',
        description: "Turn on our ready-to-send campaigns. While you focus on clients, we'll take care of the rest.",
        buttonText: 'Setup automated campaigns',
        onPrimaryClick: onSetupAutomatedCampaign,
        onClose: onClose,
        Icon: LightningIcon,
    },
}); };
